// utils/useCountdown.js
import { ref } from "vue";

let timer = null; // 全局唯一定时器

export function useCountdown(endTime,t) {
  const timeText = ref("");
  const remain = ref(0); // 剩余毫秒

  const calcRemain = () => {
    const end = typeof endTime === "string" ? new Date(endTime).getTime() : endTime;
    const now = Date.now();
    remain.value = Math.max(end - now, 0);

    if (remain.value <= 0) {
      timeText.value = t('utils.a1',{value:0,value2:'00',value3:'00',value4:'00'});
      stop();
      return;
    }

    const totalSec = Math.floor(remain.value / 1000);

    const days = Math.floor(totalSec / (3600 * 24));
    const hours = Math.floor((totalSec % (3600 * 24)) / 3600);
    const minutes = Math.floor((totalSec % 3600) / 60);
    const seconds = totalSec % 60;

    timeText.value = t('utils.a1',{value:days,value2:String(hours).padStart(2, "0"),value3:String(minutes).padStart(2, "0"),value4:String(seconds).padStart(2, "0")});
  };

  const start = () => {
    stop(); // 防止多个定时器
    calcRemain();

    timer = setInterval(() => {
      calcRemain();
    }, 1000);
  };

  const stop = () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  };

  return {
    timeText,
    remain,
    start,
    stop
  };
}
